import "../components/ChatBubble.css"

export default function ChatBubble(props) {
    return (
        <div className = "chat-bubble" style = 
        {{
            padding: '20px', 
            border: 'solid', 
            borderStyle: props.user === 'KC Social Nest' ? 'none' : 'solid', 
            borderColor: 'rgba(255, 255, 255, 0.3)', 
            borderRadius: '7px', 
            borderWidth: '1px', 
            width: '100%', 
            boxSizing: 'border-box',
            width: '90%',
            marginLeft: props.user == 'KC Social Nest' ? '0px' : 'auto',
            marginRight: props.user == 'KC Social Nest' ? 'auto' : '0px'

        }}>
            <p style = {{fontFamily: 'Montserrat-Bold'}}>{props.user}:</p>
            <p dangerouslySetInnerHTML={{ __html: props.text }}></p>
        </div>
    )
}